import BigNumber from 'bignumber.js'
import { Token } from 'config/types'
import Column from 'layout/Components/Column'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { useStoredSearchToken } from 'views/Payment/MobilePayment/components/PaymentTokenSelectModal/useStoredSearchToken'
import { useAvailableDepositTokens } from 'views/Payment/MobilePayment/hooks/useTokens'
import CurrencySelectDropdown from './CurrencySelectDropdown'
import NetworkSelectDropdown from './NetworkSelectDropdown'

const PaymentNetworkCurrencyDropdown: React.FC<{
  selectedCurrency: Token
  disabled?: boolean
  onCurrencySelect: (token: Token) => void
  fetchTokenBalanceFn?: (token: Token) => Promise<BigNumber>
  hideHUSDToken?: boolean
  isIncludeFiat?: boolean
  hideNetwork?: boolean
  from?: PaymentPageEnums
}> = ({
  selectedCurrency,
  disabled,
  onCurrencySelect,
  fetchTokenBalanceFn,
  hideHUSDToken,
  isIncludeFiat,
  hideNetwork,
  from = PaymentPageEnums.Deposit,
}) => {
  const storedSearch = useStoredSearchToken(from)
  const {
    isValidAddress,
    networkInfo,
    networksCurrencySameCode,
    currenciesGroupSameCode,
    currencies,
    handleSelectNetwork,
  } = useAvailableDepositTokens({
    onCurrencySelect: (token) => {
      storedSearch.record(token.code, token.address, token.network, hideNetwork)
      onCurrencySelect(token)
    },
    selectedCurrency,
    hideHUSDToken,
    isIncludeFiat,
  })

  return (
    <Column gap="20px">
      <CurrencySelectDropdown
        disabled={disabled}
        value={selectedCurrency}
        onTokenChange={onCurrencySelect}
        fetchTokenBalanceFn={isValidAddress ? fetchTokenBalanceFn : null}
        options={currenciesGroupSameCode}
        isIncludeFiat={isIncludeFiat}
        hideNetwork={hideNetwork}
        allCurrencies={currencies}
        from={from}
      />
      <NetworkSelectDropdown
        disabled={disabled}
        value={networkInfo?.network}
        onValueChange={handleSelectNetwork}
        options={networksCurrencySameCode[selectedCurrency?.code] || []}
      />
    </Column>
  )
}

export default PaymentNetworkCurrencyDropdown
